/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-01-23T10:16:01-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-13T11:46:05-07:00
*/



import React from 'react'
import { css, StyleSheet } from 'aphrodite/no-important';
import { type, textColor, spacing, leading } from '../../style';
import {tsDate} from "../../common";

const style = StyleSheet.create({
  tripDates: {
    display: 'table',
    width: '100%'
  },

  date: {
    display: 'table-cell',
    width: '41.66667%',
    ...type.SM,
    ...textColor.DARKER,
    ...type.BOLD,
    lineHeight: '19px',
    textAlign: 'left',
    whiteSpace: 'nowrap'
  },

  dateLabel: {
    ...textColor.LIGHTER,
    textTransform: 'uppercase',
    ...type.XS,
  },

  rightSide: {
    textAlign: 'right'
  },

  dateSeperator: {
    textAlign: 'center',
    width: '16.66667%',
    display: 'table-cell',
    verticalAlign: 'middle'
  },
})

const TripDates = (props) => {

  const {
    leaveDt,
    returnDt
  } = props

  function renderDate(dateVal, right) {
    return (
      <div className={css(style.date, right && style.rightSide)}>
        {tsDate(dateVal)}
        <div className={css(style.dateLabel)}>{ !right ? 'Leaving' : 'Returning'}</div>
      </div>
    )
  }

  return(
    <div className={css(style.tripDates)}>
      {renderDate(leaveDt)}
      <div className={css(style.dateSeperator)}>
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="16" viewBox="0 0 22 40">
          <polygon points="2.133 0 .055 2.076 17.846 19.972 .055 37.868 2.133 39.945 21.987 19.972"/>
        </svg>
      </div>
      {renderDate(returnDt, true)}
    </div>
  )};

export default TripDates;



// WEBPACK FOOTER //
// ./src/components/blocks/TripDates.jsx